laiCustomShopReviewAvg = parseFloat(laiCustomShopReviewAvg).toFixed(1);

function createLAICustomShopReviewBlock() {
  var _ = document.querySelector('.lai-custom-shop-review-wrapper');
  if (_) {
    _.innerHTML = `
      <h3 class="lai-custom-shop-review-total">${laiCustomShopReviewTotal} Reviews</h3>
      <div class="lai-custom-shop-review-star-container">
        <svg
          width="37"
          height="33"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7 12.4001L7.2 10.7001L7 10.6001L6.8 10.7001L3.4 12.4001L4 8.6001V8.3001L3.8 8.1001L1 5.4001L4.9 4.8001H5.2L5.3 4.6001L7 1.1001L8.7 4.6001L8.8 4.8001H9.1L12.9 5.4001L10.1 8.1001L9.9 8.3001V8.6001L10.7 12.4001Z"
            fill="#D03531"
          ></path>
          <path
            d="M7 2.3L5.8 4.9L5.6 5.4L5.1 5.5L2.2 5.9L4.2 7.9L4.6 8.3L4.5 8.8L4 11.6L6.5 10.3L7 10.1L7.5 10.3L10.1 11.6L9.6 8.8L9.5 8.3L9.9 7.9L11.9 5.9L9.1 5.5L8.6 5.4L8.4 4.9L7 2.3ZM7 0L9.2 4.4L14 5.1L10.5 8.5L11.4 13.3L7 11.1L2.7 13.3L3.5 8.5L0 5.1L4.9 4.4L7 0Z"
            fill="#D03531"
          ></path>
        </svg>
        <svg
          width="37"
          height="33"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7 12.4001L7.2 10.7001L7 10.6001L6.8 10.7001L3.4 12.4001L4 8.6001V8.3001L3.8 8.1001L1 5.4001L4.9 4.8001H5.2L5.3 4.6001L7 1.1001L8.7 4.6001L8.8 4.8001H9.1L12.9 5.4001L10.1 8.1001L9.9 8.3001V8.6001L10.7 12.4001Z"
            fill="#D03531"
          ></path>
          <path
            d="M7 2.3L5.8 4.9L5.6 5.4L5.1 5.5L2.2 5.9L4.2 7.9L4.6 8.3L4.5 8.8L4 11.6L6.5 10.3L7 10.1L7.5 10.3L10.1 11.6L9.6 8.8L9.5 8.3L9.9 7.9L11.9 5.9L9.1 5.5L8.6 5.4L8.4 4.9L7 2.3ZM7 0L9.2 4.4L14 5.1L10.5 8.5L11.4 13.3L7 11.1L2.7 13.3L3.5 8.5L0 5.1L4.9 4.4L7 0Z"
            fill="#D03531"
          ></path>
        </svg>
        <svg
          width="37"
          height="33"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7 12.4001L7.2 10.7001L7 10.6001L6.8 10.7001L3.4 12.4001L4 8.6001V8.3001L3.8 8.1001L1 5.4001L4.9 4.8001H5.2L5.3 4.6001L7 1.1001L8.7 4.6001L8.8 4.8001H9.1L12.9 5.4001L10.1 8.1001L9.9 8.3001V8.6001L10.7 12.4001Z"
            fill="#D03531"
          ></path>
          <path
            d="M7 2.3L5.8 4.9L5.6 5.4L5.1 5.5L2.2 5.9L4.2 7.9L4.6 8.3L4.5 8.8L4 11.6L6.5 10.3L7 10.1L7.5 10.3L10.1 11.6L9.6 8.8L9.5 8.3L9.9 7.9L11.9 5.9L9.1 5.5L8.6 5.4L8.4 4.9L7 2.3ZM7 0L9.2 4.4L14 5.1L10.5 8.5L11.4 13.3L7 11.1L2.7 13.3L3.5 8.5L0 5.1L4.9 4.4L7 0Z"
            fill="#D03531"
          ></path>
        </svg>
        <svg
          width="37"
          height="33"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.7 12.4001L7.2 10.7001L7 10.6001L6.8 10.7001L3.4 12.4001L4 8.6001V8.3001L3.8 8.1001L1 5.4001L4.9 4.8001H5.2L5.3 4.6001L7 1.1001L8.7 4.6001L8.8 4.8001H9.1L12.9 5.4001L10.1 8.1001L9.9 8.3001V8.6001L10.7 12.4001Z"
            fill="#D03531"
          ></path>
          <path
            d="M7 2.3L5.8 4.9L5.6 5.4L5.1 5.5L2.2 5.9L4.2 7.9L4.6 8.3L4.5 8.8L4 11.6L6.5 10.3L7 10.1L7.5 10.3L10.1 11.6L9.6 8.8L9.5 8.3L9.9 7.9L11.9 5.9L9.1 5.5L8.6 5.4L8.4 4.9L7 2.3ZM7 0L9.2 4.4L14 5.1L10.5 8.5L11.4 13.3L7 11.1L2.7 13.3L3.5 8.5L0 5.1L4.9 4.4L7 0Z"
            fill="#D03531"
          ></path>
        </svg>
        <svg
          width="37"
          height="33"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 2.2L5.7 4.8L5.5 5.3L5 5.4L2.2 5.8L4.2 7.8L4.6 8.2L4.5 8.7L4 11.5L6.5 10.2L7 10L7.5 10.2L10 11.5L9.5 8.7L9.4 8.2L9.8 7.8L11.8 5.8L9 5.4L8.5 5.3L8.3 4.8L7 2.2ZM7 0L9.2 4.4L14 5.1L10.5 8.5L11.3 13.3L7 11.1L2.7 13.3L3.5 8.5L0 5.1L4.8 4.4L7 0Z"
            fill="#D03531"
          ></path>
          <path
            d="M3.5 8.5L0 5.1L4.8 4.4L7 0V11.1L2.7 13.3L3.5 8.5Z"
            fill="#D03531"
          ></path>
        </svg>
      </div>
      <p class="lai-custom-shop-review-average">Average: ${laiCustomShopReviewAvg} Stars</p>
    `;
  }
}
Shopify.designMode &&
  document.addEventListener('shopify:section:load', function () {
    createLAICustomShopReviewBlock();
  }),
  (window.onload = function () {
    createLAICustomShopReviewBlock();
  });
